module.exports = __webpack_public_path__ + "input-password.png";